import { useQuery } from 'react-query';
import { network } from 'services/network';

const getCriticalPathRemovedTableData = (params) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filterData,
    };
    return network
        .post('api/bo/getTopCriticalPathRemoved', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryCriticalPathRemovedTableData = (params) => {
    return useQuery(['criticalPathRemovedTableData', params], () => getCriticalPathRemovedTableData(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
